import { reactive,  watch } from "vue";
import { useRouter } from "@library/Services";
import { CarbucksProfile, type ICarbucksProfile, type ICarbucksProfileDto } from "@domain/Carbucks";
import { useUserSettings } from "@services/UserSettings";
import type { ICarbucksViewModel } from "./ICarbucksViewModel";
import { isDemo, isDevelopment } from "@modules/Utilities/Environments";

export class CarbucksViewModel implements ICarbucksViewModel
{

    isLoaded: boolean = false;
    profile: ICarbucksProfile = { isLoaded: false } as ICarbucksProfile;
    button = reactive( { isVisible: false } );

    constructor( model: ICarbucksProfileDto )
    {

        // Its possible (prior to completing the welcome flow) for the
        // Carbucks Profile to be null, if so leave it in an isLoaded false state
        if( model == null ) return;

        handleMockData( model );
        
        this.profile = new CarbucksProfile( model );
        this.isLoaded = model != null;

        // If the route changes, close the navigation bar
        const router = useRouter();
        watch( () => router.current.value.path, async path =>
        {
            
            // Only show the button on these pages
            const isMyGarage = path == '/my-garage';
            const isMarketplace = path == '/my-marketplace';
            const userSettings = useUserSettings();

            this.button.isVisible = isMyGarage || ( isMarketplace && userSettings.isFirstMarketplaceVisit == false );

        }, { immediate: true } );

    }

}

function handleMockData( model: ICarbucksProfileDto )
{
    const settings = useUserSettings();
    if( isDemo() || ( isDevelopment() && settings.enableDemoLinkedCards == false ) )
    {
        model.linkedCards = [];
    }
}